export const ExtendedPaymentMethodsEvents = {} as const;

export const ExtendedPaymentMethodsActions = {
  Collapse: 'extended-payment-methods-collapse-all',
} as const;

export const collapseExtendedPaymentMethods = () => {
  const collapseEvent = new CustomEvent(
    ExtendedPaymentMethodsActions.Collapse,
    {
      detail: {},
      bubbles: true,
    },
  );
  window.dispatchEvent(collapseEvent);
};
